import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setParticipantDetails, setToken } from "store/authSlice";
import { useNavigate } from "react-router-dom";
import Spinner from "common/Spinner/Spinner";
import ErrorMessage from "common/ErrorMessage/ErrorMessage";
import {
  useLazyGetAuthTokenQuery,
  useLazyGetParticipantInfoQuery,
} from "service/APIService";
import { useLocation } from "react-router";

const Auth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [authMutation, { isLoading }] = useLazyGetAuthTokenQuery();
  const [participantMutation, { isLoading: isLoading1 }] =
    useLazyGetParticipantInfoQuery();
  const [errors, setErrors] = useState(null);

  useEffect(() => {
    setErrors(null);
    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const state = params.get("state");
    if (code && state) {
      authMutation({
        code: code,
        state: state,
      })
        .unwrap()
        .then((res) => {
          dispatch(setToken(res));
          participantMutation()
            .unwrap()
            .then((response) => {
              dispatch(setParticipantDetails(response));
              if (response?.guestPpt) {
                navigate("/learning-center");
              } else {
                navigate("/dashboard");
              }
            });
        })
        .catch((err) => {
          setErrors(err?.data);
        });
    }
  }, [location]);

  return (
    <section className="p-4 position-relative" style={{ height: "100vh" }}>
      {(isLoading || isLoading1) && <Spinner />}
      {errors && <ErrorMessage error={errors} wrapperClassName="mb-2" />}
    </section>
  );
};

export default Auth;
